import React from 'react';
import KpiStrip from './KpiStrip';

export default function DashboardRollingStats({ items, ariaLabel }) {
  const normalizedItems = items.map((item) => ({
    ...item,
    unitInline: Boolean(item.unit),
  }));

  return (
    <KpiStrip
      items={normalizedItems}
      variant="stats-compact"
      className="dashboard-rolling-stats"
      ariaLabel={ariaLabel}
    />
  );
}